import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { getConcurrences, getConcurrencesList } from '../../../graph-ql/concurrences/concurrences.queries';
import { getQuotationsList } from '../../../graph-ql/quotations/quotations.queries';
import { sendInvitation } from '../../../graph-ql/leadinLive/leadinLive.mutation';
import {
  addComment,
  archiveLead,
  assignLeadsMutation,
  assignLeadToMe,
  closeLead,
  deleteLeadsMutation,
  doTrack,
  editLeadMutation,
  editLeadsMutation,
  finishCall, importLeadsMutation, makeCall,
  newLeadMutation,
  reminderLead,
  revertCloseLead,
  sendEmailContact,
  sendWhatsAppContact,
  transferFlag,
  transferLeadsMutation,
  transitionToTrack,
  unAssignLeadsMutation,
  unTransferLeadsMutation,
  visitConfirmation,
  visitLead
} from '../../../graph-ql/mutations';
import { getPotentialSellers, getPotentialSellersCount, getSimulatedPotentialSellers } from '../../../graph-ql/potentialSellers/potentialSellers.queries';
import {
  canMakeCallQuery, customFilterCounts, getClosestEvent, getLastVisitByLeadId, getLeadById, getLeads,
  getLeadsByPlate,
  getLinkInvitation, getMetricLeadById, getOriginsQuery, getRawHtml, getTokenMeetByShortId, validateCsv
} from '../../../graph-ql/queries';
import { DropdownWithRulesInput } from '../../../shared/models/lead/dropdownWithRules.input';
import { GetPotentialSellersInput } from '../../../shared/models/lead/getPotentialSellers.input';
import { BrandInput } from '../../models/brand/brand.input';
import { ChannelInput } from '../../models/channel/channel.input';
import { DealerInput } from '../../models/dealer/dealer.input';
import { AddCommentInput } from '../../models/lead/addComment.input';
import { ArchiveLeadInput } from '../../models/lead/archiveLead.input';
import { AssignLeadsInput } from '../../models/lead/assignLeads.input';
import { CanMakeCallInput } from '../../models/lead/canMakeCall.input';
import { CloseLeadInput } from '../../models/lead/closeLead.input.1';
import { LeadsCustomFilterCounts } from '../../models/lead/customFilterCounts.dto';
import { DeleteLeadsInput } from '../../models/lead/deleteLeads.input';
import { DoTrackInput } from '../../models/lead/doTrackInput.input';
import { EditLeadInput } from '../../models/lead/editLead.Input';
import { EditLeadsInput } from '../../models/lead/editLeads.input';
import { FinishCallInput } from '../../models/lead/finishCall.input';
import { GetClosestEventInput } from '../../models/lead/getClosestEvents.input';
import { GetConcurrenceInput } from '../../models/lead/getConcurrence.input';
import { GetLastVisitByLeadIdInput } from '../../models/lead/getLastVisitByLeadId.input';
import { GetOfferIdLeadsByOffersId } from '../../models/lead/getLeadByOffersId.input';
import { GetLeadsResponse } from '../../models/lead/getLeads.response';
import { GetLeadsInput } from '../../models/lead/getLeadsInput';
import { GetListConcurrenceInput } from '../../models/lead/getListConcurrence.input';
import { GetOriginsInput } from '../../models/lead/getOrigins.input';
import { GetOriginsResponse } from '../../models/lead/getOrigins.response';
import { GetSimulatedPotentialSellersInput } from '../../models/lead/getSimulatedPotentialSellers.input';
import { LeadByidResponse } from '../../models/lead/leadByid.response';
import { LeadIdInput } from '../../models/lead/leadId.input';
import { LeadOfConcurrencesList } from '../../models/lead/leadOfConcurrencesList';
import { LeadPlateInput } from '../../models/lead/leadPlate.input';
import { LeadRawHtmlResponse } from '../../models/lead/leadRawHtml.response';
import { LeadsConcurrencesResponse } from '../../models/lead/leadsConcurrences.response';
import { LeadsImportInput } from '../../models/lead/leadsImport.input';
import { MakeCallInput } from '../../models/lead/makeCall.input';
import { NewLeadInput } from '../../models/lead/newLead.input';
import { ReminderLeadInput } from '../../models/lead/reminderLead.input';
import { SendInvitationInputDto } from '../../models/lead/sendInvitation.input';
import { SendEmailContactInput } from '../../models/lead/sendMail.input';
import { SendWhatsAppContactInput } from '../../models/lead/sendWhatsapp.input';
import { TransferLeadsInput } from '../../models/lead/transferLeads.input';
import { TransferredInput } from '../../models/lead/transferred.input';
import { TransitionToOnTrackInput } from '../../models/lead/transitionToTrack.input';
import { UnAssignLeadsInput } from '../../models/lead/unAssignLeads.input';
import { UnTransferLeadsInput } from '../../models/lead/unTransferLeads.input';
import { UserInput } from '../../models/lead/userInput';
import { VisitConfirmationInput } from '../../models/lead/visitConfirmation.input';
import { VisitLeadInput } from '../../models/lead/visitLead.input';
import { MetricLeadResponse } from '../../models/metricLead/metricLead.response';
import { TranslatorService } from '../utils/translator.service';
import { Event } from './../../../shared/models/calendar/event';
import { LeadPotentialSeller } from './../../../shared/models/lead/leadPotentialSeller';
import { LeadsPotentialSellersCountResponse } from './../../../shared/models/lead/leadsPotentialSellersCount.response';
import { RevertCloseLeadInput } from './../../models/lead/revertCloseLead.input';
import { GetListQuotationsInput } from './../../models/lead/getListQuotations.input';
import { LeadOfQuotationsList } from './../../models/lead/leadOfQuotationsList';

@Injectable()
export class LeadService {

  constructor(public apollo: Apollo, private readonly translationService: TranslatorService) {
  }

  getRawHtml$(leadIdInput: LeadIdInput): Observable<LeadRawHtmlResponse> {
    return this.apollo.query<LeadRawHtmlResponse>({
      query: getRawHtml,
      variables: {
        leadInput: leadIdInput

      }
    })
      .pipe(map(result =>
        new LeadRawHtmlResponse(
          result.data['getRawHtml']['emailSubject'],
          result.data['getRawHtml']['rawHtml'],
          result.data['getRawHtml']['rawText']
        )));
  }

  getLeadById$(leadIdInput: LeadIdInput, addHasMessageId = false): Observable<LeadByidResponse> {
    return this.apollo.query<LeadByidResponse>({
      query: getLeadById,
      variables: {
        input: leadIdInput,
        addHasMessageId
      }
    })
      .pipe(map(result =>
        new LeadByidResponse(
          result.data['getLeadById']['lead']
        )));
  }

  getLeadsByPlate$(leadPlateInput: LeadPlateInput, addHasMessageId = false): Observable<GetLeadsResponse> {
    return this.apollo.query<GetLeadsResponse>({
      query: getLeadsByPlate,
      variables: {
        input: leadPlateInput
      }
    })
      .pipe(map(result => {
        if (!result.data['getLeadsByPlate']) {
          return new GetLeadsResponse([], 0);
        }
        return new GetLeadsResponse(
          result.data['getLeadsByPlate']['leads'],
          result.data['getLeadsByPlate']['totalCount']
        );
      }));

  }

  getMetricLeadById$(leadIdInput: LeadIdInput): Observable<MetricLeadResponse> {
    return this.apollo.query<MetricLeadResponse>({
      query: getMetricLeadById,
      variables: {
        input: leadIdInput
      }
    })
      .pipe(map(result =>
        new MetricLeadResponse(
          result.data['getMetricLeadById']['metricLead']
        )
      ));
  }

  getLastVisitByLeadId$(leadIdInput: GetLastVisitByLeadIdInput): Observable<Event> {
    return this.apollo.query<Event>({
      query: getLastVisitByLeadId,
      variables: {
        input: leadIdInput
      }
    })
      .pipe(map(result =>
        new Event(
          result.data['getLastVisitByLeadId']
        )
      ));
  }

  getLeads$(leadInput: GetLeadsInput, isDownloadCsv = false): Observable<GetLeadsResponse> {
    return this.apollo.query<GetLeadsResponse>({
      query: getLeads,
      variables: {
        input: leadInput,
        isDownloadCsv
      }
    })
      .pipe(map(result => {
        if (!result.data['getLeads']) {
          return new GetLeadsResponse([], 0);
        }
        return new GetLeadsResponse(
          result.data['getLeads']['leads'],
          result.data['getLeads']['totalCount']
        );
      }
      ));
  }
  customFilterCounts$(): Observable<LeadsCustomFilterCounts> {
    return this.apollo.query<LeadsCustomFilterCounts>({
      query: customFilterCounts
    })
      .pipe(map(result => {

        if (!result.data['customFilterCounts']) {
          return new LeadsCustomFilterCounts();
        }
        return new LeadsCustomFilterCounts(result.data['customFilterCounts']['customFilterCounts']);
      }
      ));
  }

  getClosestEvent$(getClosestEventsInput: GetClosestEventInput[]): Observable<Event[]> {
    return this.apollo.query<Event[]>({
      query: getClosestEvent,
      variables: {
        input: getClosestEventsInput
      }
    })
      .pipe(map(result => {
        if (!result.data['getClosestEvent']) {
          return [];
        }
        return result.data['getClosestEvent'].map(event => new Event(event));
      }));
  }

  deleteLeads$(deleteLeadsInput: DeleteLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: deleteLeadsMutation,
        variables: {
          input: {
            leadIds: deleteLeadsInput.leadsIds,
            comments: deleteLeadsInput.comments
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not delete');
        }

        return result;
      }));
  }

  assignLeads$(assignLeadsInput: AssignLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: assignLeadsMutation,
        variables: {
          input: {
            leadIds: assignLeadsInput.leadIds,
            userId: assignLeadsInput.userId,
            comments: assignLeadsInput.comments
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not assigned');
        }

        return result;
      }));
  }
  unAssignLeads$(unAssignLeadsInput: UnAssignLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: unAssignLeadsMutation,
        variables: {
          input: {
            leadIds: unAssignLeadsInput.leadIds,
            comments: unAssignLeadsInput.comments,
            comingFromCallModal: unAssignLeadsInput.comingFromCallModal
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not assigned');
        }

        return result;
      }));
  }

  assignLeadToMe$(leadIdInput: LeadIdInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: assignLeadToMe,
        variables: {
          input: leadIdInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not assigned');
        }

        return result;
      }));
  }

  newLead$(newLeadInput: NewLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: newLeadMutation,
        variables: {
          input: {
            lead: newLeadInput.lead
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not created');
        }

        return result;
      }));
  }

  transferLeads$(transferLeadsInput: TransferLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: transferLeadsMutation,
        variables: {
          input: {
            leadIds: transferLeadsInput.leadIds,
            userId: transferLeadsInput.userId,
            comments: transferLeadsInput.comments
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not transferred');
        }

        return result;
      }));
  }

  unTransferLeads$(unTransferLeadsInput: UnTransferLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: unTransferLeadsMutation,
        variables: {
          input: {
            leadIds: unTransferLeadsInput.leadIds,
            comments: unTransferLeadsInput.comments
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not transferred');
        }

        return result;
      }));
  }

  editLead$(editLeadInput: EditLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: editLeadMutation,
        variables: {
          input: editLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not edit');
        }

        return result;
      }));
  }

  editLeads$(editLeadsInput: EditLeadsInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: editLeadsMutation,
        variables: {
          input: editLeadsInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Leads not edited');
        }

        return result;
      }));
  }

  sendEmailContact$(sendEmailContactInput: SendEmailContactInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: sendEmailContact,
        variables: {
          input: sendEmailContactInput
        }
      });
  }
  sendInvitation$(sendInvitationInputDto: SendInvitationInputDto): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: sendInvitation,
        variables: {
          input: sendInvitationInputDto
        }
      });
  }

  sendWhatsAppContact$(sendWhatsAppContactInput: SendWhatsAppContactInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: sendWhatsAppContact,
        variables: {
          input: sendWhatsAppContactInput
        }
      });
  }

  doTrack$(doTrackInput: DoTrackInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: doTrack,
        variables: {
          input: doTrackInput
        }
      });
  }

  archiveLead$(archiveLeadInput: ArchiveLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: archiveLead,
        variables: {
          input: archiveLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  reminderLead$(reminderLeadInput: ReminderLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: reminderLead,
        variables: {
          input: reminderLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  closeLead$(closeLeadInput: CloseLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: closeLead,
        variables: {
          input: closeLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  revertCloseLead$(revertCloseLeadInput: RevertCloseLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: revertCloseLead,
        variables: {
          input: revertCloseLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  visitLead$(visitLeadInput: VisitLeadInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: visitLead,
        variables: {
          input: visitLeadInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  makeCall$(makeCallInput: MakeCallInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: makeCall,
        variables: {
          input: makeCallInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result.data;
      }));
  }

  canMakeCall$(canMakeCallInput: CanMakeCallInput): Observable<any> {
    return this.apollo.query<any>({
      query: canMakeCallQuery,
      variables: {
        input: canMakeCallInput
      }
    })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result.data.canMakeCall;
      }));
  }

  validateCsv(
    brandInput: BrandInput,
    dealerInput: DealerInput,
    channelInput: ChannelInput,
    userInput: UserInput,
    getOfferIdLeadsByOfferIdInput: GetOfferIdLeadsByOffersId
  ): Observable<any> {
    return this.apollo
      .query<any>({
        query: validateCsv,
        variables: {
          brandInput,
          dealerInput,
          channelInput,
          userInput,
          getOfferIdLeadsByOfferIdInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result;
      }));
  }

  importLeads$(leadsImportInput: LeadsImportInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: importLeadsMutation,
        variables: {
          input: {
            leadsImportInput: leadsImportInput.leadsImport
          }
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw new Error('Lead not imported');
        }

        return result;
      }));
  }

  finishCall$(finishCallInput: FinishCallInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: finishCall,
        variables: {
          input: finishCallInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result.data;
      }));
  }

  addComment$(addCommentInput: AddCommentInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: addComment,
        variables: {
          input: addCommentInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result.data;
      }));
  }

  transferFlag$(transferredInput: TransferredInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: transferFlag,
        variables: {
          input: transferredInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }

        return result.data;
      }));
  }

  getOrigins$(getOriginsInput: GetOriginsInput, dropdownWithRulesInput: DropdownWithRulesInput): Observable<GetOriginsResponse> {
    return this.apollo.query<GetOriginsResponse>({
      query: getOriginsQuery,
      variables: {
        getOriginsInput: {
          origin: getOriginsInput.origin,
          dropdownWithRulesInput: {
            channel: dropdownWithRulesInput.channel,
            dropdownWithRulesFlag: dropdownWithRulesInput.dropdownWithRulesFlag
          }
        }
      }
    })
      .pipe(map(result => {
        if (!result.data['getOrigins']) {
          return new GetOriginsResponse([]);
        }
        return new GetOriginsResponse(
          result.data['getOrigins']['origins'],
          result.data['getOrigins']['canCreateNew']
        );

      }
      ));
  }

  getConcurrence(getConcurrenceInput: GetConcurrenceInput): Observable<Observable<LeadsConcurrencesResponse> | any> {
    return this.apollo.query<LeadsConcurrencesResponse>({
      query: getConcurrences,
      variables: {
        input: getConcurrenceInput
      }
    })
      .pipe(map(
        result => {
          const response = new LeadsConcurrencesResponse();
          if (result.errors) {
            return { error: result.errors };
          }
          response.leads = result.data['getConcurrences']['leads'];
          return response;
        }
      ));
  }

  getPotentialSellersCount(getPotentialSellersInput: GetPotentialSellersInput): Observable<Observable<LeadsPotentialSellersCountResponse> | any> {
    return this.apollo.query<LeadsPotentialSellersCountResponse>({
      query: getPotentialSellersCount,
      variables: {
        input: getPotentialSellersInput
      }
    })
      .pipe(map(
        result => {
          const response = new LeadsPotentialSellersCountResponse();
          if (result.errors) {
            return { error: result.errors };
          }
          response.leads = result.data['getPotentialSellersCount']['leads'];
          return response;
        }
      ));
  }

  getPotentialSellers(getPotentialSellerIdInput: LeadIdInput): Observable<Observable<LeadPotentialSeller> | any> {
    return this.apollo.query<LeadPotentialSeller>({
      query: getPotentialSellers,
      variables: {
        input: getPotentialSellerIdInput
      }
    })
      .pipe(map(
        result => {
          const response = new LeadPotentialSeller();
          if (result.errors) {
            return { error: result.errors };
          }
          response.potentialSellers = result.data['getPotentialSellers']['potentialSellers'];
          return response;
        }
      ));
  }
  getSimulatedPotentialSellers(getSimulatedPotentialSellerInput: GetSimulatedPotentialSellersInput): Observable<Observable<LeadPotentialSeller> | any> {
    return this.apollo.query<LeadPotentialSeller>({
      query: getSimulatedPotentialSellers,
      variables: {
        input: getSimulatedPotentialSellerInput
      }
    })
      .pipe(map(
        result => {
          const response = new LeadPotentialSeller();
          if (result.errors) {
            return { error: result.errors };
          }
          response.potentialSellers = result.data['getSimulatedPotentialSellers']['potentialSellers'];
          return response;
        }
      ));
  }

  getListConcurrence(getListConcurrenceInput: GetListConcurrenceInput): Observable<LeadOfConcurrencesList[]> {
    return this.apollo.query<LeadOfConcurrencesList[]>({
      query: getConcurrencesList,
      variables: {
        input: getListConcurrenceInput
      }
    })
      .pipe(map(
        result => {
          let response = new Array<LeadOfConcurrencesList>();
          response = result.data['getConcurrencesList'];
          return response;
        }
      ));
  }

  getListQuotations(getListQuotationsInput: GetListQuotationsInput): Observable<LeadOfQuotationsList[]> {

    return this.apollo.query<LeadOfQuotationsList[]>({
      query: getQuotationsList,
      variables: {
        input: getListQuotationsInput
      }
    })
      .pipe(map(
        result => {
          let response = new Array<LeadOfQuotationsList>();
          response = result.data['getQuotationsList'];
          return response;
        }
      ));    
  }

  getLinkInvitation$(leadId: string): Observable<any> {
    return this.apollo.query<any>({
      query: getLinkInvitation,
      variables: {
        input: leadId
      }
    }).pipe(map(result => {
      return result.data['getLinkInvitation'];
    }));

  }

  getTokenMeetByShortId$(shortId: string): Observable<any> {
    return this.apollo.query<any>({
      query: getTokenMeetByShortId,
      variables: {
        input: shortId
      }
    }).pipe(map(result => {
      return result.data['getTokenMeetByShortId'];
    }));

  }

  transitionToTrack$(transitionToTrackInput: TransitionToOnTrackInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: transitionToTrack,
        variables: {
          input: transitionToTrackInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }
        return result.data;
      }));
  }

  visitConfirmation$(visitConfirmationInput: VisitConfirmationInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: visitConfirmation,
        variables: {
          input: visitConfirmationInput
        }
      })
      .pipe(map(result => {
        if (result.errors && result.errors.length > 0) {
          throw Error(this.getMessagesErrors(result.errors));
        }
        return result.data;
      }));
  }

  private getMessagesErrors(errors: any): string {
    for (const error of errors) {
      return `${this.translationService.trans(error.message)}<br/>`;
    }
  }

}
